<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-expansion-panels accordion v-model="panel">
                    <v-expansion-panel key="1">
                      <v-expansion-panel-header>Wyszukiwanie</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                  <v-autocomplete v-model="selected_client" :loading="isLoadingClients"
                                    :items="clientsList" :search-input.sync="clientKeyword" cache-items flat
                                    no-data-text="Nieznaleziono" hide-details return-object item-text="name"
                                    item-value="id" clearable label="Wyszukaj pacjenta Imię/Nazwisko/PESEL">
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                  <v-autocomplete v-model="selected_therapist" name="therapistId"
                                    :loading="isLoadingTherapists" :items="therapists" flat return-object hide-details
                                    clearable prepend-icon="fa-search" label="Wyszukaj terapeute Imię/Nazwisko">
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                  <v-checkbox label="Pokaż po terminie" v-model="showInactive"></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="getData()">Szukaj</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table :headers="headers" :items="reserves" :options.sync="options"
                    :server-items-length="totalCount" :loading="loading" :footer-props="{
                      itemsPerPageOptions: [50, 100, 200, 500],
                    }" class="elevation-1">
                    <template v-slot:item="props">
                      <tr>
                        <td>{{ props.item.client.name + ' ' + props.item.client.surname }}</td>
                        <td>{{ props.item.therapist.name + ' ' + props.item.therapist.surname }}</td>
                        <td>{{ getPriority(props.item.priority) }}</td>
                        <td>{{ props.item.reserve_date_description }}</td>
                        <td>{{ props.item.reserve_hours_description }}</td>
                        <td>{{ props.item.visit_time }} minut</td>
                        <td>{{ props.item.creator }}</td>
                        <td>{{ props.item.notes }}</td>
                        <td>{{ getFormattedDateVisit(props.item.visit_date) }}</td>
                        <td>{{ props.item.visit_therapist }}</td>
                        <td>
                          <v-icon small class="mr-2" @click="editReserve(props.item)"
                            v-if="$can('do', 'POKO_RezerwyEdycja') && props.item.visit_id == 0"
                            title="Edytuj wizyte rezerwową">fa-edit</v-icon>
                          <v-icon small class="mr-2" @click="deleteReserve(props.item)"
                            v-if="$can('do', 'POKO_RezerwyUsuwanie') && props.item.visit_id == 0"
                            title="Usuń wizyte rezerwową">fa-trash</v-icon>
                          <v-icon small class="mr-2" @click="showVisitHistory(props.item)"
                            v-if="$can('do', 'POKO_Wizyty')" title="Historia wizyt pacjenta">fa-history</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <EditReserve v-if="showEdit" :visible="showEdit" :id="wybrany_id" @close="closedEdit"></EditReserve>
      </v-col>
    </v-row>
    <v-dialog v-model="showHistory" max-width="1200px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Historia wizyt pacjenta</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeHistory">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <MedicalVisitHistory v-if="showHistory" :clientid="historyClientId"></MedicalVisitHistory>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { voucheryService } from "@/services/vouchery.service";
import * as dayjs from "dayjs";
import swal from "sweetalert";
import { reserveService, therapistsService, visitService } from "@/services";
import { clientService } from "@/services"
import i18next from 'i18next'
import EditReserve from "@/components/reserves/EditReserve";
import MedicalVisitHistory from "@/components/clients/MedicalVisitHistory";



export default {
  name: "ListReserves",
  components: { EditReserve, MedicalVisitHistory },
  props: ["therapistId"],
  data() {
    return {
      loading: false,
      totalCount: 0,
      reserves: [],
      options: {},
      showEdit: false,
      wybrany_id: 0,
      panel: -1,
      selected_client: null,
      isLoadingClients: false,
      clientKeyword: null,
      clientTimerId: 0,
      clientsList: [],
      showInactive: false,
      headers: [
        { text: '', align: 'left', value: 'client.id' },
        { text: '', align: 'left', value: 'therapist.id' },
        { text: 'Priorytet', align: 'left', value: 'priority' },
        { text: 'Termin', align: 'left', value: 'reserve_date_description' },
        { text: 'Godziny', align: 'left', value: 'reserve_hours_description' },
        { text: 'Czas wizyty', align: 'left', value: 'visit_time' },
        { text: 'Kto dodał', align: 'left', value: 'creator' },
        { text: 'Uwagi', align: 'left', value: 'notes' },
        { text: 'Data wizyty', align: 'left', value: 'visit_date' },
        { text: 'Terapeuta wizyty', align: 'left', value: 'visit_therapist' },
        { text: 'Akcje', align: 'left', value: 'id' },
      ],
      selected_therapist: null,
      isLoadingTherapists: false,
      therapists: [],
      showHistory: false,
      historyClientId: 0
    }
  },
  mounted() {
    this.headers[0].text = i18next.t('FE_KLIENT')
    this.headers[1].text = i18next.t('FE_PRACOWNIK')
    this.loadTherapists()
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    closedEdit() {
      this.showEdit = false
      this.getData()
    },
    fetchClientDebaunce() {
      // cancel pending call
      clearTimeout(this.clientTimerId)
      // delay new call 500ms
      this.clientTimerId = setTimeout(() => {
        this.getClientValues()
      }, 500)
    },
    loadTherapists() {
      this.isLoadingTherapists = true;
      therapistsService
        .getAll({ query: '', page: 1, limit: 1000 })
        .then(response => {
          if (
            response.data != null &&
            response.data.result != null &&
            response.data.result.items != null
          ) {

            response.data.result.items.forEach((r, index) => {
              if (!this.therapists.find(x => x.id === r.id))
                this.therapists.push({
                  id: r.id,
                  text: r.name + " " + r.surname,
                  pay: r.rate,
                  disabled: false
                });
            });
            if (this.therapistId && this.therapistId > 0) {
              this.selected_therapist = this.therapists.find(x => x.id == this.therapistId)
              this.getData()
              this.panel = 1
            }
            this.isLoadingTherapists = false;
          } else {
            throw "error pobierania terapeutów";
          }
        })
        .catch(e => {
          this.isLoadingTherapists = false;
          this.showError("Nie można pobrać listy terapeutów.");
        });
    },
    getClientValues() {
      this.isLoadingClients = true;
      clientService
        .getAll({ query: this.clientKeyword, page: 1, limit: 20, sorting: "surname" })
        .then(data => {
          data.data.result.items.forEach(item => {
            if (!this.clientsList.find(x => x.id === item.id)) {
              let name = item.name + " " + item.surname;
              this.clientsList.push({
                id: item.id,
                name: name
              });
            }
          });
          this.isLoadingClients = false;
        })
        .catch(() => {
          this.isLoadingClients = false;
          this.showError("Nie można pobrać listy klientów.");
        });
    },
    getData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sortValue = ''
      if (sortBy.length > 0) {
        sortValue = sortBy[0]
        if (sortDesc.length > 0)
          sortValue = sortBy[0] + (sortDesc[0] ? " DESC" : "");
      }
      this.loading = true
      reserveService.getAll({
        Sorting: sortValue,
        TherapistID: this.selected_therapist != null ? this.selected_therapist.id : 0,
        ClientID: this.selected_client != null ? this.selected_client.id : 0,
        showInactive: this.showInactive,
        SkipCount: (page - 1) * itemsPerPage,
        MaxResultCount: itemsPerPage
      }).then(result => {
        this.reserves = result.data.result.items
        this.totalCount = result.data.result.totalCount
        this.loading = false
      }).catch(() => {
        this.showError('Błąd pobierania rezerw.')
        this.loading = false
      })
    },
    getFormattedDate(val) {
      if (val == null) {
        return 'Bezterminowy'
      }
      let dj = dayjs(val)
      if (dj != null) {
        return dj.format("DD-MM-YYYY")
      }
      else {
        return val
      }
    },
    editReserve(item) {
      this.wybrany_id = item.id
      this.showEdit = true
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    deleteReserve(item) {
      swal({
        title: "Czy na pewno?",
        text:
          "Czy na pewno chcesz usunąć tą wizyte rezerową?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          reserveService.deleteReserve(item.id).then(() => {
            this.getData()
          }).catch(e => {
            if (
              e.response != null &&
              e.response.data != null &&
              e.response.data.error != null
            ) {
              this.error(e.response.data.error.message)
            } else {
              this.error('Błąd usuwania wizyty rezerwowej')
            }
          })
        }
      });

    },
    getPriority(priority) {
      switch (priority) {
        case 0:
          return 'Normalny';
        case 1:
          return 'Terapeuty';
        case 2:
          return 'VIP';
      }
      return 'Normalny';
    },
    getFormattedDateVisit(val) {

      if (val) {
        let dj = dayjs(val)

        if (dj != null) {
          return dj.format("DD-MM-YYYY HH:mm")
        } else {
          return ''
        }
      }
      return ''
    },
    showVisitHistory(item) {
      this.historyClientId = item.client.id
      this.showHistory = true
    },
    closeHistory() {
      this.showHistory = false
      this.historyClientId = 0
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    },
    clientKeyword(val) {
      if (val) {
        this.fetchClientDebaunce();
      }
    },
  },
}
</script>

<style scoped></style>
